import { render } from "./gang-change-group.vue?vue&type=template&id=7bd16484"
import script from "./gang-change-group.vue?vue&type=script&lang=js"
export * from "./gang-change-group.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__